import Theme from './Theme.css'
import Body from './Body.css'
import BodySupport from './BodySupport'
import Breadcrumbs from './Breadcrumbs.css'
import BreadcrumbsSupport from './BreadcrumbsSupport'
import Button from './Button.css'
import ButtonSupport from './ButtonSupport'
import Checkbox from './Checkbox.css'
import CheckboxSupport from './CheckboxSupport'
import ComboboxSupport from './ComboboxSupport'
import CompositeTextInput from './CompositeTextInput.css'
import CompositeTextInputSupport from './CompositeTextInputSupport'
import DataBlock from './DataBlock.css'
import DataBlockSupport from './DataBlockSupport'
import DateTimePicker from './DateTimePicker.css'
import DateTimePickerSupport from './DateTimePickerSupport'
import DateTimePickerV2 from './DateTimePickerV2.css'
import DateTimePickerV2Support from './DateTimePickerV2Support'
import DateTimeRangePicker from './DateTimeRangePicker.css'
import DateTimeRangePickerSupport from './DateTimeRangePickerSupport'
import DropdownSupport from './DropdownSupport'
import Flex from './Flex.css'
import FlexSupport from './FlexSupport'
import Label from './Label.css'
import LabelSupport from './LabelSupport'
import List from './List.css'
import ListSupport from './ListSupport'
import MultiSelectSupport from './MultiSelectSupport'
import MultiSelector from './MultiSelector.css'
import MultiSelectorSupport from './MultiSelectorSupport'
import Pane from './Pane.css'
import PaneSupport from './PaneSupport'
import Popup from './Popup.css'
import PopupSupport from './PopupSupport'
import Portal from './Portal.css'
import PortalSupport from './PortalSupport'
import ProgressBar from './ProgressBar.css'
import ProgressBarSupport from './ProgressBarSupport'
import PropertyGrid from './PropertyGrid.css'
import PropertyGridSupport from './PropertyGridSupport'
import RadioButton from './RadioButton.css'
import RadioButtonSupport from './RadioButtonSupport'
import Slider from './Slider.css'
import SliderSupport from './SliderSupport'
import SplitPane from './SplitPane.css'
import SplitPaneSupport from './SplitPaneSupport'
import TabPane from './TabPane.css'
import TabPaneSupport from './TabPaneSupport'
import Table from './Table.css'
import TableSupport from './TableSupport'
import TableV2 from './TableV2.css'
import TableV2Support from './TableV2Support'
import Text from './Text.css'
import TextSupport from './TextSupport'
import TextArea from './TextArea.css'
import TextAreaSupport from './TextAreaSupport'
import TextInput from './TextInput.css'
import TextInputSupport from './TextInputSupport'
import Toast from './Toast.css'
import ToastSupport from './ToastSupport'
import Toggle from './Toggle.css'
import ToggleSupport from './ToggleSupport'
import ToggleButton from './ToggleButton.css'
import ToggleButtonSupport from './ToggleButtonSupport'
import VTableSupport from './VTableSupport'
import ElementSupport from './ElementSupport'


function addScript( src ) {
  const script = document.createElement( "script" )
  script.crossOrigin = "anonymous"
  script.src = src
  document.head.appendChild( script )
}

addScript( 'https://kit.fontawesome.com/8846456f0e.js' )


const styles = {
  Body,
  Breadcrumbs,
  Button,
  Checkbox,
  CompositeTextInput,
  DataBlock,
  DateTimePicker,
  DateTimePickerV2,
  DateTimeRangePicker,
  Flex,
  Label,
  List,
  MultiSelector,
  Pane,
  Popup,
  Portal,
  ProgressBar,
  PropertyGrid,
  RadioButton,
  Slider,
  SplitPane,
  TabPane,
  Table,
  TableV2,
  Text,
  TextArea,
  TextInput,
  Toast,
  Toggle,
  ToggleButton
}
const supports = {
  Body : BodySupport,
  Breadcrumbs : BreadcrumbsSupport,
  Button : ButtonSupport,
  Checkbox : CheckboxSupport,
  Combobox : ComboboxSupport,
  CompositeTextInput : CompositeTextInputSupport,
  DataBlock : DataBlockSupport,
  DateTimePicker : DateTimePickerSupport,
  DateTimePickerV2 : DateTimePickerV2Support,
  DateTimeRangePicker : DateTimeRangePickerSupport,
  Dropdown : DropdownSupport,
  Flex : FlexSupport,
  Label : LabelSupport,
  List : ListSupport,
  MultiSelect : MultiSelectSupport,
  MultiSelector : MultiSelectorSupport,
  Pane : PaneSupport,
  Popup : PopupSupport,
  Portal : PortalSupport,
  ProgressBar : ProgressBarSupport,
  PropertyGrid : PropertyGridSupport,
  RadioButton : RadioButtonSupport,
  Slider : SliderSupport,
  SplitPane : SplitPaneSupport,
  TabPane : TabPaneSupport,
  Table : TableSupport,
  TableV2 : TableV2Support,
  Text : TextSupport,
  TextArea : TextAreaSupport,
  TextInput : TextInputSupport,
  Toast : ToastSupport,
  Toggle : ToggleSupport,
  ToggleButton : ToggleButtonSupport,
  VTable : VTableSupport,
  Element : ElementSupport
}
const color = {
  "FocusVisBorder": "#4ba5f5",
  "attributeCellEditable": "@color:brand300",
  "base025": "#f9fafb",
  "base050": "#f3f5f6",
  "base100": "#e7eaef",
  "base200": "#ced6de",
  "base300": "#acb7c3",
  "base400": "#95a2b2",
  "base500": "#67798e",
  "base600": "#495a6e",
  "base700": "#394756",
  "base800": "#29323d",
  "base900": "#181e25",
  "brand025": "#d2dce6",
  "brand050": "#bccbda",
  "brand100": "#90a8c1",
  "brand200": "#7997b5",
  "brand300": "#5e87ee",
  "brand400": "#36628f",
  "brand500": "#205183",
  "brand600": "#1d4976",
  "brand700": "#16395c",
  "brand800": "#0024ac",
  "brand900": "#001b98",
  "columnValue": "@color:base600",
  "danger050": "#ffebed",
  "danger100": "#fdd8dd",
  "danger500": "#cb3c48",
  "danger700": "#aa2a30",
  "danger900": "#65171c",
  "detailEvenRow": "rgba(243, 245, 246, 0.46)",
  "detailOddRow": "transparent",
  "dropTarget": "@color:base100",
  "graphBackground": "#ffffff",
  "graphSeries1": "#2258c0",
  "graphSeries10": "#976a41",
  "graphSeries2": "#f4b85d",
  "graphSeries3": "#e7803e",
  "graphSeries4": "#b057d4",
  "graphSeries5": "#f4dc5d",
  "graphSeries6": "#6ab3a4",
  "graphSeries7": "#5b8bf6",
  "graphSeries8": "#42c6c8",
  "graphSeries9": "#cb4183",
  "graphThreshold": "@color:danger700",
  "graphXAxisLabel": "@color:base700",
  "graphXAxisLine": "@color:base200",
  "graphXTickLabel": "@color:base700",
  "graphYAxisLabel": "@color:base700",
  "graphYAxisLine": "@color:base200",
  "graphYTickLabel": "@color:base700",
  "linkHover": "#1d4976",
  "linkNormal": "#205183",
  "linkVisited": "#90a8c1",
  "mainNavPane": "#181e25",
  "overlay": "#808080",
  "secondaryBrand050": "#c7eaea",
  "secondaryBrand100": "#9edcdc",
  "secondaryBrand500": "#44b9b9",
  "secondaryBrand700": "#1d9a9a",
  "secondaryBrand900": "#308282",
  "shadowBase": "rgba(41, 50, 61, 0.16)",
  "sort100": "#add5dd",
  "sort50": "#d3e7eb",
  "sort500": "#0c8599",
  "success050": "#edfdf8",
  "success100": "#dafbf0",
  "success300": "#1ae5a1",
  "success500": "#15b982",
  "success700": "#0e815a",
  "success900": "#084934",
  "tableFiltered": "rgba(190, 208, 249, 0.2)",
  "tableRollover": "@color:brand025",
  "tableRolloverSelected": "@color:brand200",
  "tableSelected": "@color:brand100",
  "tableSorted": "rgba(211, 231, 235, 0.32)",
  "tertiaryBrandA": "#15b982",
  "tertiaryBrandA300": "#ff9f5f",
  "tertiaryBrandA500": "#f67a28",
  "tertiaryBrandB": "#ffb647",
  "tertiaryBrandB300": "#fdcd84",
  "tertiaryBrandB500": "#ffb647",
  "tertiaryBrandC": "#f67a28",
  "tertiaryBrandC300": "#42d3a3",
  "tertiaryBrandC500": "#15b982",
  "tertiaryBrandD": "#0f5dfa",
  "tertiaryBrandD300": "#4f89ff",
  "tertiaryBrandD500": "#0f5dfa",
  "warning050": "#fef3eb",
  "warning100": "#fde7d8",
  "warning500": "#f67a28",
  "warning700": "#c45308",
  "warning900": "#8d3b04",
  "white": "#ffffff",
  "ScreenIcon": "#4c8447",
  "ScreenIconBackground": "#dae5db",
  "SideNavCollapseBackground": "#ffffff",
  "SideNavCollapseBorder": "#ced6de",
  "SideNavDivider": "#bdc4cf",
  "SideNavHeader": "#394756",
  "SideNavHover": "rgba(76, 132, 71, 0.18)",
  "SideNavIcon": "#4c8447",
  "SideNavOn": "rgba(76, 132, 71, 0.24)",
  "SideNavPane": "#f3f5f9",
  "SideNavPressed": "rgba(76, 132, 71, 0.3)",
  "SideNavText": "#394756",
  "SideNavTextSelected": "#4c8447",
  "TopNavBorder": "#ffffff",
  "TopNavDivider": "#5f7c9a",
  "TopNavHover": "rgba(255, 255, 255, 0.18)",
  "TopNavIcon": "#ffffff",
  "TopNavOn": "rgba(255, 255, 255, 0.2)",
  "TopNavPane": "#205183",
  "TopNavPressed": "rgba(255, 255, 255, 0.3)",
  "TopNavText": "#ffffff",
  "TopNavTextSelected": "#ffffff",
  "bespokeErrorBorder": "#b8142a",
  "bespokeSuccessBorder": "#029e2e",
  "bespokeWarningBorder": "#ef6407",
  "pillErrorBackground": "#f7c8cd",
  "pillErrorBorder": "#b8142a",
  "pillSuccessBackground": "#def3e6",
  "pillSuccessBorder": "#029e2e",
  "stageInactiveBdr": "#ced6de",
  "stageInactiveBg": "#e7eaef",
  "stageInfusionBdr": "#324f9a",
  "stageInfusionBg": "#bdcaed",
  "stageInspectionBdr": "#b95a15",
  "stageInspectionBg": "#f4cfb4",
  "stageLayupBdr": "#36788c",
  "stageLayupBg": "#acd2de",
  "stagePostBdr": "#783290",
  "stagePostBg": "#e5caee",
  "stagePrepBdr": "#0c6b40",
  "stagePrepBg": "#bff0cd",
  "stageWebBdr": "#783290",
  "stageWebBg": "#e5caee"
}
const icon = {
  "add-group": "fak fa-lv-add-group",
  "aggregate-bar-chart": "fak fa-lv-dv-aggregate-bar-chart",
  "aggregate-pie-chart": "fak fa-lv-aggregate-pie-chart",
  "all-items-dashboard": "fak fa-lv-all-items-dashboard",
  "api-access-key": "fak fa-lv-api-access-key-large",
  "architect-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-call-architect.svg",
  "arrow-left": "fak fa-lv-arrow-right",
  "arrow-right": "fak fa-lv-arrow-right",
  "associated-id": "fak fa-lv-associated-id",
  "attribute-pie-chart": "fak fa-lv-attribute-pie-chart",
  "bulk-create": "fak fa-lv-bulk-create",
  "calendar": "fak fa-lv-calendar",
  "camera": "fak fa-lv-camera",
  "cancel": "fak fa-lv-cancel",
  "center-address": "fak fa-lv-center-address",
  "check": "fak fa-lv-check",
  "chevron-down-large": "fak fa-lv-chevron-down-large",
  "chevron-down-small": "fak fa-lv-chevron-down-small",
  "chevron-left-large": "fak fa-lv-chevron-left-large",
  "chevron-left-small": "fak fa-lv-chevron-left-small",
  "chevron-right-large": "fak fa-lv-chevron-right-large",
  "chevron-right-small": "fak fa-lv-chevron-right-small",
  "chevron-up-large": "fak fa-lv-chevron-up-large",
  "chevron-up-small": "fak fa-lv-chevron-up-small",
  "clear": "fak fa-lv-clear",
  "close": "fak fa-lv-cancel",
  "compute-agg-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-compute-aggregation.svg",
  "conditionSelector": "fa fa-fw fa-dog",
  "configuration": "fak fa-lv-configuration",
  "copy": "fak fa-lv-copy",
  "copy-to-clipboard": "fak fa-lv-copy",
  "cow": "fa-kit fa-lv-cow",
  "create": "fak fa-lv-create",
  "current-location": "fak fa-lv-current-location",
  "dash": "fak fa-lv-dash",
  "dashboard": "fak fa-lv-dashboard",
  "delete": "fak fa-lv-delete",
  "details": "fak fa-lv-details",
  "details-block": "fak fa-lv-details-block",
  "details-filled": "fak fa-lv-details-filled",
  "edit": "fak fa-lv-edit",
  "edit-device-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-edit-device-attribute.svg",
  "email-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-send-email.svg",
  "event-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-create-event.svg",
  "farm": "fa-kit fa-lv-farm",
  "farm-corporation": "fa-kit fa-lv-farm-corporation",
  "filter": "fak fa-lv-filter",
  "gear": "fak fa-lv-gear",
  "geoshape-nearest-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-get-nearest-geoshape.svg",
  "grabberIcon": "fak fa-lv-rearrange",
  "grid": "fak fa-lv-dv-grid",
  "grid-options": "fak fa-lv-grid-options",
  "group": "fak fa-lv-group",
  "group-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-rule-group.svg",
  "hardware": "fak fa-lv-hardware",
  "help": "fak fa-lv-help",
  "help-filled": "fak fa-lv-help-filled",
  "hide": "fak fa-lv-hide",
  "history-pie-chart": "fak fa-lv-history-pie-chart",
  "history-table-list": "fak fa-lv-dv-history-table-list",
  "history-table-list-filled": "fa-kit fa-lv-dv-history-table-list-filled",
  "history-xy-chart": "fak fa-lv-dv-history-xy-chart",
  "if-then": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-if-then.svg",
  "image": "fak fa-lv-image",
  "info": "fak fa-lv-info",
  "info-filled": "fak fa-lv-info-filled",
  "layout": "fak fa-lv-layout",
  "load-form": "fak fa-lv-load-form",
  "log-out": "fak fa-lv-log-out",
  "log-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-log-value-source.svg",
  "low-battery": "fak fa-lv-low-battery",
  "lvg-logo": "fak fa-lv-lvg-logo",
  "map": "fak fa-lv-dv-map",
  "menu": "fak fa-lv-menu",
  "more": "fak fa-lv-more",
  "more-h": "fa fa-ellipsis fa-fw",
  "multi-image": "fak fa-lv-multi-image",
  "operating-hours-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-operating-hours.svg",
  "overrideFormIcon": "fak fa-lv-refresh",
  "pair": "fak fa-lv-pair",
  "placeholder": "fak fa-lv-placeholder",
  "profileMenu": "fa-kit fa-lv-avatar-placeholder",
  "rearrange": "fak fa-lv-rearrange",
  "refresh": "fak fa-lv-refresh",
  "remove": "fak fa-lv-remove",
  "reset": "fak fa-lv-reset",
  "rules": "fa-kit fa-lv-rules",
  "satellite": "fak fa-lv-satellite",
  "save": "fak fa-lv-save",
  "save-to": "fak fa-lv-save-to",
  "search": "fak fa-lv-search",
  "search-geoshapes-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-search-geoshapes.svg",
  "selected-items-dashboard": "fak fa-lv-selected-items-dashboard",
  "set-var": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-set-variable.svg",
  "settings": "fak fa-lv-settings",
  "settings-gear-filled": "fak fa-lv-settings-gear-filled",
  "show": "fak fa-lv-show",
  "single-image": "fak fa-lv-single-image",
  "slack-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-slack-message.svg",
  "sms-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-send-sms.svg",
  "sort": "fak fa-lv-sort",
  "stop": "fak fa-lv-stop",
  "success": "fak fa-lv-success",
  "table-list": "fak fa-lv-dv-table-list",
  "time": "fak fa-lv-time",
  "transfer": "fak fa-lv-transfer",
  "trash": "fak fa-lv-delete",
  "unpair": "fak fa-lv-unpair",
  "update": "fak fa-lv-update",
  "upload": "fak fa-lv-upload",
  "user": "fak fa-lv-user",
  "users": "fa-kit fa-lv-users",
  "warning-filled": "fak fa-lv-warning-filled",
  "webhook-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-call-webhook.svg",
  "resourceUsersScreen": "fa-kit fa-lv-users"
}
const size = {
  "attributeCellEditable": "2px",
  "borderRadiusMedium": "4px",
  "borderRadiusSmall": "2px",
  "fontBody": "16px",
  "fontBodySmall": "15px",
  "fontButtonMedium": "15px",
  "fontButtonSmall": "12px",
  "fontCaption": "13px",
  "fontCaptionSmall": "12px",
  "fontH1": "20px",
  "fontH2": "18px",
  "fontH3": "16px",
  "large": "16px",
  "medium": "8px",
  "negative": "-4px",
  "pad12": "12px",
  "padLarge": "16px",
  "padMedium": "8px",
  "padSmall": "4px",
  "padXLarge": "24px",
  "padXXLarge": "32px",
  "portalMaxWidth": "504px",
  "propertyGridColumnGap": "8px",
  "propertyGridRowGap": "8px",
  "small": "4px"
}
const resources = { color, icon, size }

export default { styles, supports, resources }